import * as React from 'react';
import './backtagModal.scss';
import { Modal } from 'rcd-cpp-ui/ui/modal/Modal';
import { useSelector } from '../../../utils/useSelector';
import { NodeType } from '../../../enums/NodeType';
import { getSchema } from '../../../utils';
import { Field } from '../../MetadataForm/metadataFormField';
import { Metadata, SchemaField } from '../../../types/Metadata';
import { Buttons, Cancel, Save } from 'rcd-cpp-ui/ui/button';
import { useActions } from './backtagModalActions';
import { useLoader } from '../../Loader/loader';
import { useAlert } from '../../Alert/alert';
import { FormUpdater } from '../../../types/Field';

interface Props {
  onClose: () => any;
}

export const BacktagModal = ({ onClose }: Props) => {
  const [data, setData] = React.useState<Metadata>({ props: {} } as any);
  const { addBackTags, Loader, Alert, isLoading, setMessage } = useAlert(
    useLoader(useActions())
  );
  const itemSchema = useSelector(s =>
    getSchema(s.planning.selectedWorkspace.schemas, NodeType.Item)
  );
  const backtagFields = itemSchema?.props?.fields?.filter(
    f => f.parentField == 'backtag'
  );
  const totalCount = useSelector(s => s.view?.info?.count);
  const itemRefIds = useSelector(s => {
    const refIds = s.view?.info?.refIds;
    const isCheckedAll = s.view?.isCheckedAll;
    const toggledRefIds = s.view?.toggledRefIds || [];
    if (isCheckedAll) {
      return refIds?.filter(id => !toggledRefIds.includes(id));
    } else {
      return toggledRefIds;
    }
  });
  const count = itemRefIds?.length || totalCount || 0;
  const updater: FormUpdater = React.useMemo(
    () => ({
      update: async () => {},
      reset: () => {},
      updateField: () => {},
      updateData: (field: SchemaField, value) => {
        data.props[field.field] = value;
        setData({ ...data, props: data.props });
      },
      updateFields: fields => {
        fields.forEach(({ field, value }) => {
          data.props[field.field] = value;
        });
        setData({ ...data, props: data.props });
      }
    }),
    [data]
  );
  React.useEffect(() => {
    if (itemRefIds == null && totalCount > 0) {
      setMessage(
        'More than 5,000 items selected. Please reduce the selection and try again.'
      );
    }
  }, [itemRefIds, totalCount]);
  const hasValue = Object.entries(data.props).reduce((bool, [k, v]) => {
    if (bool) return true;
    if (k.startsWith('staged') && Array.isArray(v) && v.length > 0) return true;
    return false;
  }, false);
  return (
    <Modal
      id="backtagModal"
      header={`Add Tags (${count.toLocaleString()} Items Selected)`}
      onClose={onClose}
    >
      <Loader />
      <Alert />
      <div>Select Tags</div>
      <div className="metadata-form">
        {backtagFields?.map(f => {
          return (
            <Field
              key={f.field}
              field={f}
              schema={itemSchema}
              updater={updater}
              data={data}
            />
          );
        })}
      </div>
      <Buttons>
        <Cancel onClick={onClose} />
        <Save
          disabled={isLoading || !itemRefIds?.length || !hasValue}
          onClick={() => {
            setMessage(null);
            addBackTags(itemRefIds, data).then(() => {
              onClose();
            });
          }}
        />
      </Buttons>
    </Modal>
  );
};
